import { readonly, ref } from 'vue'

type Tone = 'ok' | 'danger' | 'neutral'

export interface Toast {
  readonly id: number
  readonly tone: Tone
  readonly message: string
}

const OK_DISMISS_MS = 5000

const toasts = ref<Toast[]>([])
let nextId = 0

function dismiss(id: number): void {
  toasts.value = toasts.value.filter((toast) => toast.id !== id)
}

/** The app-wide outcome-message queue. */
export function useToasts() {
  function push(tone: Tone, message: string): void {
    const id = ++nextId
    toasts.value = [...toasts.value, { id, tone, message }]
    if (tone !== 'danger') setTimeout(() => dismiss(id), OK_DISMISS_MS)
  }
  return { toasts: readonly(toasts), push, dismiss }
}
